import { RecentlyViewed } from 'src/components/sidebar-panels/recently-viewed'
import { YourLists } from 'src/components/sidebar-panels/your-lists'

export const MapExplorerDefaultPanel = () => {
  return (
    <>
      <YourLists />
      <RecentlyViewed />
    </>
  )
}
